import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

if (process.env.REACT_APP_E2E_EMULATOR_SIGNIN === 'true') {
	import('./e2eAuthBridge').then((m) => m.installE2EAuthBridge());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App/>
	</React.StrictMode>
);

const onIdle = (cb) => {
	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(cb, { timeout: 2000 });
	} else {
		setTimeout(cb, 1000);
	}
};

onIdle(() => {
	import('./reportWebVitals').then((m) => {
		const run = m?.default || m?.reportWebVitals;
		if (typeof run === 'function') {
			run();
		}
	});
});
